var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinedOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h24v17H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h30v30H-3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#80959D",
    d: "M.5.5h23v16H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#80959D",
    d: "M8.693 21.23H6.03a1.1 1.1 0 0 0-1.1 1.1v.802h14v-.714a1.1 1.1 0 0 0-1.1-1.1h-2.554v-2.186l-6.646.048.063 2.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80959D",
    d: "M15.414 9.87l-1.011 1.363-1.549-6.128 5.454 3.313-1.627.546 1.864 2.412-1.278.965z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinedOn);
export default __webpack_public_path__ + "static/media/joined-on.7b67237724d39be0fdb571669bf6f835.svg";
export { ForwardRef as ReactComponent };